import { memo } from "react"

const IconConsumptionCard = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <rect x="0.5" width="24" height="24" rx="5.33333" fill="#7B78E1" fill-opacity="0.3" />
      <path
        d="M6.5 10.0013V8.0013C6.5 7.26464 7.09667 6.66797 7.83333 6.66797H17.1667C17.9033 6.66797 18.5 7.26464 18.5 8.0013V16.0013C18.5 16.738 17.9033 17.3346 17.1667 17.3346H13.1667"
        stroke="#002C98"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5007 17.3307L10.3333 16.9107C10.2487 16.6981 10.1173 16.5067 9.94932 16.3514V16.3514C9.66465 16.0874 9.29065 15.9414 8.90332 15.9414H7.43132C7.04332 15.9414 6.66998 16.0881 6.38532 16.3514V16.3514C6.21732 16.5067 6.08598 16.6981 6.00132 16.9107L5.83398 17.3307"
        stroke="#002C98"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.9915 12.342C9.44683 12.7973 9.44683 13.536 8.9915 13.992C8.53617 14.4473 7.7975 14.4473 7.3415 13.992C6.88617 13.5367 6.88617 12.798 7.3415 12.342C7.7975 11.886 8.53617 11.886 8.9915 12.342"
        stroke="#002C98"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M11.8333 14V10" stroke="#002C98" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13.8333 13.9985V11.7852" stroke="#002C98" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15.8333 14.0005V10.3672" stroke="#002C98" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export default memo(IconConsumptionCard)
